import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { BankCbrfDto } from '@/modules/common/dto/bank-cbrf.dto.ts';
import type { BankCBRF } from '@/modules/common/adapters/bank-cbrf.type.ts';

export class BankCbrfAdapter {
  private static map(response: BankCbrfDto): BankCBRF {
    return {
      name: response.bank_name,
      identificationCode: response.bik,
      correspondentAccount: response.kc,
    };
  }

  static mapList(response: ItemsDto<BankCbrfDto>) {
    return response.items.map(BankCbrfAdapter.map);
  }
}
